import TextareaQuestionSurface from "./TextareaQuestionSurface";

export const SURFACE_16_LABEL = "Anything the AI should know or avoid?";
export const SURFACE_16_HELPER = "Sore spots, sensitive topics, anything to steer clear of. Optional -- but the AI will use it.";
export const SURFACE_16_PLACEHOLDER = "Anything you'd want the AI to handle gently, or not at all...";

export default function Surface16(props) {
  return (
    <TextareaQuestionSurface
      current={12}
      label={SURFACE_16_LABEL}
      helper={SURFACE_16_HELPER}
      placeholder={SURFACE_16_PLACEHOLDER}
      name="recipient_avoid"
      optional
      {...props}
    />
  );
}
